/**
 * 接口文档
 *  http://api-doc-sl.inshopline.com/#/project/80/feature%2F20210907_v1.0.0/interface/bb9915819e0390807f25dc807e07a222/call
 */
export default {
  /** 创建单个订单 */
  singleCreate: '/api/sales/outbounds/create',
  /** 编辑单个订单 */
  singleUpdate: '/api/sales/outbounds/update',
  /**
   * @deprecated
   * 执行出货
   * */
  shipment: '/api/sales/outbounds/shipment',
  /**
   * @deprecated
   * 执行拦截
   * */
  intercept: '/api/sales/outbounds/intercept',
  /**批量拦截 */
  batchIntercept: '/api/sales/outbounds/batch-intercept',
  /**订单列表 */
  list: '/api/sales/outbounds/search',
  /**批量导入*/
  batchImport: '/api/tasks/import',
  eMapUrl: '/api/emap/get-url',
  searchOrderById: '/api/sales/outbounds/search-order-id',
  /**
   * 导入模版链接
   * @deprecated
   * */
  importUrl: '/api/sales/outbounds/import-url',
  /** 挂起订单 */
  hangUpOrder: '/api/sales/outbounds/batch-hand-up',
  /** 解挂订单 */
  hangDownOrder: '/api/sales/outbounds/batch-hand-down',
  /** 获取订单标签总数 */
  orderTagsInfo: '/api/sales/outbounds/search-count',
  /**批量作废订单*/
  bathchCancelUrl: '/api/sales/outbounds/batch-cancel',
  /**批量释放库存*/
  batchReleaseUrl: '/api/sales/outbounds/batch-release',
  /** 无需处理（门店关转） */
  ignoreAbnormalUrl: '/api/abnormal/outbounds/ignoreAbnormal',
  /**获取订单物流轨迹 */
  trackListUrl: '/api/sales/outbounds/track/list',
  /** 修改门店/出货日期 */
  updateStationUrl: '/api/abnormal/outbounds/updateStation',
  /**获取订单列表 */
  searchListUrl: '/api/sales/outbounds/search',
  /** 批量更新物流/仓库 */
  batchUpdateExpress: '/api/sales/outbounds/update-express',
  /**改变物流状态 */
  changeExpressEnable: '/api/seller-express/enable',
  batchChangeExpressEnable: '/api/seller-express/batchEnable',
  /**改变物流状态 */
  updateExpress: '/api/seller-express/update',

  /** 批量更新偏好物流设置 */
  batchUpdateSellerExpress: '/api/seller-express/batch-update',

  /**根据skuId查询组合商品详情 */
  checkSkuGroup: 'api/spu-sku-group/search',

  /**获取电子地图站点 */
  getStation: '/api/emap/get-station',

  /**批量取消拆单 */
  cancelSplitOrderUrl: '/api/sales/outbounds/batch-cancel-split-order',
  /** 获取可拆单的订单信息 **/
  getCanSplitOrders: '/api/sales/outbounds/can-split-orders',
  /** 批量执行拆单 **/
  batchSplitOrder: '/api/sales/outbounds/batch-split-order',
  /** 批量取消拆单 **/
  batchCancelSplitOrder: '/api/sales/outbounds/batch-cancel-split-order',
  /** 获取汇率信息 */
  getExchangeRate: '/api/currency/convert',
  /**获取门店关转状态数量 */
  searchAbnormalCount: '/api/sales/outbounds/search-abnormal-count',
  /**获取待出库已出库的门店关转数量 */
  searchPendingCount: '/api/sales/outbounds/search-pending-count',
  /**校验商品信息 */
  checkSkuOrder: '/api/sales/outbounds/check-sku-order',
  /**面单下载 */
  waybillDownload: '/api/sales/outbounds/waybill-download',
}
